import useSetUserToThirdParty from '../layout/useSetUserToThirdParty';

export default function SetUserToThirdParty() {
  useSetUserToThirdParty();

  return null;
}
